import { render, staticRenderFns } from "./Post_Component.vue?vue&type=template&id=40315290&"
import script from "./Post_Component.vue?vue&type=script&lang=js&"
export * from "./Post_Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports